//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import Categories from '@/components/dashboard/wp-dashboard/menu-manager/Categories'
import Options from '@/components/dashboard/wp-dashboard/menu-manager/Options'
import Items from '@/components/dashboard/wp-dashboard/menu-manager/Items'
import ItemGeneralInfo from '@/components/dashboard/wp-dashboard/menu-manager/ItemGeneralInfo'
import ItemOptionsLvs from '@/components/dashboard/wp-dashboard/menu-manager/ItemOptionsLvs'

export default {
    props: ['display'],
    methods: {
        closeDialog() {
            this.$emit('close-dialog')
        },
    },
    components: {
        Categories,
        Options,
        Items,
        ItemGeneralInfo,
        ItemOptionsLvs,
    },
}
